import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { ConversationListScreen } from '../../../screens/residents/messages/ConversationListScreen';
import { ConversationScreen } from '../../../screens/residents/messages/ConversationScreen';
import { NewConversationScreen } from '../../../screens/residents/messages/NewConversationScreen';

export type MessagesStackParamList = {
  ConversationList: undefined;
  Conversation: { conversationId: number; subject?: string };
  NewConversation: { initialSubject?: string } | undefined;
};

const Stack = createStackNavigator<MessagesStackParamList>();

export const MessagesStackNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        cardStyle: { backgroundColor: '#242424' },
      }}
    >
      <Stack.Screen 
        name="ConversationList" 
        component={ConversationListScreen} 
      />
      <Stack.Screen
        name="Conversation"
        component={ConversationScreen}
        options={{
          presentation: 'modal',
          headerShown: false,
          gestureEnabled: true,
        }}
      />
      <Stack.Screen
        name="NewConversation"
        component={NewConversationScreen}
        options={{
          presentation: 'modal',
          headerShown: false,
          gestureEnabled: true,
        }}
      />
    </Stack.Navigator>
  );
};
